
import React from 'react';
import Slider from 'react-slick';
import {SliderItem} from './slider-item.js';

export class SliderPanel extends React.Component {
    constructor(props) {
      super(props);
    };
  
    render() {
      var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1
      };
      var sliderdata = this.props.sliderdata;
  
      if(!sliderdata) {
        return;
      }
  
      return (
        <Slider {...settings}>
          {sliderdata.map(function (item, index) {
            return [
              <div className="slider-item">
              <SliderItem key={index + 1} className='entry-image-wrapper' url={item.img.url} position={item.background_position}/>
              </div>
            ]
          })}
        </Slider>
      );
    }
  };